import { createAction } from 'redux-actions'
import { CoreUxOrderStatus } from 'src/componentsV2/CoreUX/types/coreUxOrder.types'

export interface Cutoff {
  time: string
  userTimeZone: string
  tzShortName: string
}

export interface MetadataPayload {
  date: string
  orderStatus: CoreUxOrderStatus
  displayDate: string
  cutoff: Cutoff
}

export const updateMetadata = createAction<MetadataPayload>('UPDATE_METADATA')
export const updateOrderStatus = createAction<CoreUxOrderStatus>(
  'UPDATE_ORDER_STATUS'
)
export const resetMetadata = createAction('RESET_METADATA')
